<template>
  <div class="VVmeeting">
    <div class="Header">
      <div>
        <img :src="imgpath.VV_Header" />
      </div>
    </div>
    <div  class="box">
      <div :class="Jionshow?'Active Activeshow':'Active'">
      <div class="Active_title" id="joinMode1Label">{{$t('m.FormatOneClickEnterMeeting')}}</div>
      <div class="Active_body">
        <div class="Active_body_AM">
          <div class="Time_title">
            <div>{{$t('m.Morning')}}</div>
            <div class="Time_img">
              <img :src="imgpath.VV_date" />
            </div>
          </div>
          <div class="MeetingList">
            <div v-if="AMshow">
              <div v-if="AMdefaultshow" class="AMlist">
                <div v-for="(item,index) in AMmeetingList " :key="index" class="Active_body_info">
                  <div class="Info_name" @click="getId(item.cfIdInWeMeet)">{{item.meeting_name}}</div>
                  <div class="Info_date">{{getnowtime()}}</div>
                  <div class="Info_time">{{item.start_time}}</div>
                </div>
              </div>
              <div v-else class="AMlist">
                <div v-for="(item,index) in AMdefaultList " :key="index" class="Active_body_info">
                  <div class="Info_name" @click="getId(item.cfIdInWeMeet)">{{item.meeting_name}}</div>
                  <div class="Info_date">{{getnowtime()}}</div>
                  <div class="Info_time">{{item.start_time}}</div>
                </div>
              </div>
            </div>
            <div v-else>{{$t('m.NoArrangement')}}</div>
          </div>
          <div class="Fload">
            <div @click="AMfload">
              <img :src="AMdefaultshow?imgpath.VV_selecttop:imgpath.VV_select" />
            </div>
          </div>
        </div>
        <div class="Active_body_PM">
          <div class="Time_title">
            <div>{{$t('m.Afternoon')}}</div>
            <div class="Time_img">
              <img :src="imgpath.VV_date" />
            </div>
          </div>
          <div class="MeetingList">
            <div v-if="PMshow">
              <div v-if="PMdefaultshow" class="PMlist">
                <div v-for="(item,index) in PMmeetingList " :key="index" class="Active_body_info">
                  <div class="Info_name" @click="getId(item.cfIdInWeMeet)">{{item.meeting_name}}</div>
                  <div class="Info_date">{{getnowtime()}}</div>
                  <div class="Info_time">{{item.start_time}}</div>
                </div>
              </div>
              <div v-else class="PMlist">
                <div v-for="(item,index) in PMdefaultList " :key="index" class="Active_body_info">
                  <div class="Info_name" @click="getId(item.cfIdInWeMeet)">{{item.meeting_name}}</div>
                  <div class="Info_date">{{getnowtime()}}</div>
                  <div class="Info_time">{{item.start_time}}</div>
                </div>
              </div>
            </div>
            <div v-else>{{$t('m.NoArrangement')}}</div>
          </div>
          <div class="Fload">
            <div @click="PMfload">
              <img :src="PMdefaultshow?imgpath.VV_selecttop:imgpath.VV_select" />
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    
    <div class="Footer" id="joinMode2">
      <div class="Active_title">{{$t('m.FormatSecondClickEnterMeetingNo')}}</div>
      <div class="Active_footer">
        <div class="Active_footer_left"></div>
        <div class="Active_footer_center">
          <Input type="text" :placeholder="$t('m.PlsEnterMeetingNo')" v-model="MeetingNuber" class="Input" />
        </div>
        <div class="Active_footer_right">
          <div @click="subBotton" class="confirm">
            <img :src="imgpath.VV_call" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getMeetingsForVV,
  JoinMeeting
} from "../../assets/js/url";
export default {
  data() {
    return {
      MeetingList: [],
      MeetingNuber: "",
      terminalId: "",
      AMmeetingList: [],
      PMmeetingList: [],
      AMdefaultList: [],
      PMdefaultList: [],
      AMshow: false,
      PMshow: false,
      AMdefaultshow: false,
      PMdefaultshow: false,
      timer: null,
      Jionshow: false
    };
  },
  activated() {
    $("body").css({
      position: "fixed",
      width: "100%"
    });
    document.body.addEventListener("touchmove", bodyScroll, false);
    function bodyScroll(event) {
      event.preventDefault();
    }
    this.terminalId = this.$store.state.TremianlId;
    if (this.terminalId == "-1" || this.terminalId == "") {
      document.getElementById("joinMode2").style.display = "none";
      document.getElementById("joinMode1Label").innerHTML =
        this.$t('m.ClickNextInfoJoin');
      this.Jionshow = true;
    }
    this.timer = setInterval(() => {
      this.getmeetinglist();
    }, 5000);
  },
  mounted() {
    this.getmeetinglist();
  },
  deactivated() {
    this.$destroy();
    clearInterval(this.timer);
    this.timer = null;
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  computed: {
    imgpath() {
      return this.$store.state.imagestyle[this.$store.state.cssstyle];
    }
  },
  methods: {
    //获取会议举行日期
    getnowtime() {
      const time = new Date();
      const year = time.getFullYear();
      const mouth =
        time.getMonth() + 1 < 10
          ? "0" + (time.getMonth() + 1)
          : time.getMonth() + 1;
      const day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
      return year + "/" + mouth + "/" + day; //年月日
    },
    subBotton() {
      this.$http
        .post(JoinMeeting, {
          useruuid: window.sessionStorage.getItem("UUID"),
          terminalId: this.terminalId,
          vmrId: this.MeetingNuber
        })
        .then(res => {
		  if (res.data.status == 2000) {
            this.$toast(this.$t('m.JoinOK'));
          } else {
		      this.$toast(res.data.data.errorDes);
          }
        });
    },
    getmeetinglist() {
      this.$http
        .post(getMeetingsForVV, {
          useruuid: window.sessionStorage.getItem("UUID")
        })
        .then(res => {
          if (res.data.status == 2000) {
            this.MeetingList = res.data.data;
            this.getList();
          } else {
            this.$toast(this.$t('m.GetMeetingListFail'));
          }
        });
    },
    getList() {
      this.PMmeetingList = [];
      this.AMmeetingList = [];
      let data = this.MeetingList;
      if (data) {
        for (let i = 0; i < data.length; i++) {
          let time = data[i].start_time.split(":")[0];
          if (Number(time) >= 12) {
            this.PMmeetingList.push(data[i]);
          } else {
            this.AMmeetingList.push(data[i]);
          }
        }
        if (this.PMmeetingList.length != 0) {
          this.PMshow = true;
          this.getPMdefaultList();
        }
        if (this.AMmeetingList.length != 0) {
          this.AMshow = true;
          this.getAMdefaultList();
        }
      }
    },
    getAMdefaultList() {
      let data = this.AMmeetingList;
      if (data.length > 3) {
        this.AMdefaultList = data.filter((item, index, arr) => {
          return index < 3;
        });
      } else {
        this.AMdefaultList = data;
      }
    },
    getPMdefaultList() {
      let data = this.PMmeetingList;
      if (data.length > 4) {
        this.PMdefaultList = data.filter((item, index, arr) => {
          return index < 4;
        });
      } else {
        this.PMdefaultList = data;
      }
    },
    AMfload() {
      this.AMdefaultshow = !this.AMdefaultshow;
    },
    PMfload() {
      this.PMdefaultshow = !this.PMdefaultshow;
    },
    getId(item) {
      this.$router.push({
        path: "/DetailedInfo",
        query: {
          id: item
        }
      });
    }
  }
};
</script>
<style scoped>
html,
body {
  width: 100%;
  height: 100%;
  background-color: rgb(191, 192, 194) !important;
}
.VVmeeting {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
}
.Header {
  height: 1.8rem;
  width: 100%;
}
.Header div {
  height: 1.8rem;
  width: 100%;
}
.Header img {
  width: 100%;
  height: 100%;
}
.Active {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 1.8rem;
  left: 0;
  bottom: 0.95rem;
  right: 0;
  background: rgb(242, 242, 242);
}
.Activeshow {
  position: fixed;
  top: 1.8rem;
  left: 0;
  bottom: 0;
  right: 0;
}
.Active_title {
  height: 0.3rem;
  line-height: 0.3rem;
  font-size: 14px !important;
  padding-left: 0.2rem;
  font-weight: 800;
  /* margin-top: 3px; */
  background: linear-gradient(to right, rgb(192, 0, 0), rgb(112, 48, 160));
  color: #fff;
}
.Active_body {
  flex: 1;
  overflow: hidden;
  overflow-y: auto;
}
.Active_body::-webkit-scrollbar {
  display: none;
}
.Active_body_info {
  height: 0.3rem;
  color: black;
  border-bottom: 1px solid rgb(191, 192, 194);
  background: #fff;
}
.Info_name {
  width: 40%;
  height: 0.3rem;
  line-height: 0.3rem;
  text-decoration: rgb(191, 192, 194);
  font-size: 14px;
  text-decoration-line: underline;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Info_date,
.Info_time {
  width: 30%;
  height: 0.3rem;
  line-height: 0.3rem;
  text-align: center;
  font-size: 14px;
}
.Active_body_info > div {
  float: left;
}
.box{
  overflow: hidden;
  position: relative;
  
}
.Active_footer {
  height: 0.5rem;
  line-height: 0.5rem;
  border: 1px solid rgb(191, 192, 194);
  padding-left: 0.1rem;
  background: #fff;
}
.Active_footer_left {
  float: left;
  height: 0.1rem;
  width: 0.1rem;
  border-radius: 50%;
  background: rgb(191, 192, 194);
  margin-top: 0.2rem;
}
.Active_footer_center {
  height: 0.5rem;
  line-height: 0.45rem;
  float: left;
  margin-left: 0.1rem;
  font-size: 14px;
  width: 70%;
}
.Input {
  display: inline-block;
  height: 0.3rem;
  width: 100%;
  font-size: 14px;
  border: 1px solid #fff;
}
.Input:hover {
  border: 1 solid #dcdee2 !important;
}
.Active_footer_right {
  float: right;
  height: 0.5rem;
  width: 20%;
}
.confirm {
  height: 0.25rem;
  width: 0.25rem;
  line-height: 0.3rem;
  text-align: center;
  color: #fff;
  font-size: 14px;
  margin-top: 0.1rem;
  float: right;
  margin-right: 0.3rem;
}
.confirm img {
  width: 100%;
  height: 100%;
}
.Active_body_AM {
  min-height: 1.2rem;
}
.Time_title {
  color: black;
  font-weight: 900;
  font-size: 14px;
  height: 0.3rem;
  line-height: 0.3rem;
  padding-left: 0.2rem;
  vertical-align: middle;
  margin-top: 0.03rem;
}
.Time_title > div {
  float: left;
}
.Time_img {
  margin-left: 0.05rem;
  margin-top: 0.03rem;
  height: 0.25rem;
  width: 0.25rem;
}
.Time_img img {
  width: 100%;
  height: 100%;
}
.MeetingList {
  /* min-height: 1.2rem; */
  padding-left: 0.2rem;
  line-height: 0.4rem;
  background: #fff;
  border: 1px solid rgb(191, 192, 194);
  font-size: 14px !important;
  color: rgb(191, 192, 194);
  font-weight: 900;
}
.Footer {
  position: fixed;
  width: 100%;
  height: 0.95rem;
  bottom: 0;
}
.Fload {
  height: 0.25rem;
  width: 100%;
  margin-top: 0.05rem;
}
.Fload > div {
  height: 0.25rem;
  width: 0.25rem;
  float: right;
  margin-right: 0.3rem;
}
img {
  width: 100%;
  height: 100%;
}
.AMlist,
.PMlist > div:last-child {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/content/vvMeetingList.vue